import Vue from 'vue'
import App from './App.vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import pagination from "vuejs-uib-pagination"
import { Scroll } from '@/Directives/scroll'

// fontawesome
// Centralize Font Awesome setup via plugin
import '@/plugins/fontawesome'
// Ensure Font Awesome v6 icons are registered correctly
// The library expects individual icon definitions, not an object.
// Spread the values from our custom library object into library.add(...icons)
// Font Awesome is registered in the plugin; no local adds here

// Config
Vue.config.productionTip = false

// Dependencies
Vue.use(VueAxios, axios)
Vue.use(VueMaterial)
Vue.material.ripple = false
Vue.use(pagination)
Vue.use(require('vue-cookies'))

// Directives
Vue.directive('scroll', Scroll)

// Font Awesome component is registered globally in the plugin

// Global components
Vue.component('app', require('./App').default)

// Hide buggy error for vue-material library
Vue.config.errorHandler = (err) => {
    // Show any error but this one
  if (err.message !== "Cannot read property 'badInput' of undefined") {
    console.error(err)
  }
}

new Vue({
  render: h => h(App)
}).$mount('#catalogApp')
